/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNodeSet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M5.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2 5.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0zM18.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM15 5.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0zm-3 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM8.5 12a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0zm-3 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2 18.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0zM18.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM15 18.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgNodeSet as NodeSet };
